// extracted by mini-css-extract-plugin
module.exports = {"appShell":"AppShell_appShell__1LEAY","logo":"AppShell_logo__1BWQy","button":"AppShell_button__1uYew"};